export default "__VITE_ASSET__33973972__"